import React, { useEffect } from 'react';
import { Search } from '@mui/icons-material';
import { IconButton, TextField, InputAdornment, Button } from '@mui/material';
import {
  GridToolbarDensitySelector,
  GridToolbarContainer,
  GridToolbarColumnsButton,
} from '@mui/x-data-grid';
import FlexBetween from './FlexBetween';
import ToolbarExport from './ToolbarExport';

const DataGridCustomToolbar = ({
  searchInput,
  setSearchInput,
  setSearch,
  userRole,
  setIsFilterDialogOpen = () => {},
  showFilter = false,
  showSearch = true,
  exportType = '',
}) => {
  return (
    <GridToolbarContainer>
      <FlexBetween width='100%'>
        <FlexBetween>
          <GridToolbarColumnsButton />
          {/* <GridToolbarDensitySelector /> */}
          {/* <GridToolbarFilterButton /> */}
          {userRole === 'Admin' && exportType === 'enquiries' ? (
            <ToolbarExport exportType={exportType} />
          ) : null}
          {showFilter && (
            <Button
              variant='secondary'
              onClick={() => {
                setIsFilterDialogOpen(true);
              }}
            >
              Filters
            </Button>
          )}
        </FlexBetween>
        {showSearch && (
          <TextField
            label='Search...'
            sx={{ mb: '0.5rem', width: '15rem' }}
            onChange={(e) => setSearchInput(e.target.value)}
            value={searchInput}
            variant='standard'
            InputProps={{
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton
                    onClick={() => {
                      setSearch(searchInput);
                      setSearchInput('');
                    }}
                  >
                    <Search />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        )}
      </FlexBetween>
    </GridToolbarContainer>
  );
};

export default DataGridCustomToolbar;
